export default "__VITE_ASSET__BDjKILbX__"